import { SituacaoAuditoria } from '../../../../model/apm/apm-enums';

export const AUDIT_STATUS_COLOR: Record<SituacaoAuditoria, 'info' | 'warning' | 'success'> = {
    [SituacaoAuditoria.Entregue]: 'info',
    [SituacaoAuditoria.Sobrestado]: 'warning',
    [SituacaoAuditoria.Julgado]: 'success',
};
